import React, { useState, useEffect, useRef } from 'react';
import Scroller from 'ui-component/Scroller';
import StatusBadge from 'ui-component/StatusBadge';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import NoItemAvailableIcon from 'assets/images/icons/no-item-available.svg';
import { DeleteIcon } from 'ui-component/custom-icons/icons';
import useIsMobile from 'utils/isMobileUtils';


// ✅ Clear
const InboundListMobile = ({ operationDetails, handleRemoveProductFromList }) => {

    const topSection = useRef(null);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedProductIndex, setSelectedProductIndex] = useState(null);
    const [inboundList, setInboundList] = useState([]);
    const statusDisplayedAsInbounded = ['Verified', 'Unverified'];

    useEffect(() => {
        // Log the operationDetails for debugging
        updateInboundList();
    }, [operationDetails]);


    const updateInboundList = () => {

        // Construct a new summary details array from operationDetails.products
        const collection = operationDetails?.products?.map(product => ({
            id: product?.id,
            oldGradeId: product?.old_grade_id,
            oldGradeName: product?.old_grade_name,
            newGradeId: product?.new_grade_id,
            newGradeName: product?.new_grade_name,
            colorId: product?.color_id,
            colorName: product?.color_name,
            imei: product?.imei,
            productId: product?.product_id,
            productName: product?.product_name,
            quantity: product?.quantity,
            status: statusDisplayedAsInbounded?.includes(product?.status) ? 'Inbounded' : 'Pending',
        })) || [];
    
        // Update the summaryDetails state once with the new array
        setInboundList(collection);
    }

    const removeProductFromList = (index) => {
        setShowDelete(true);
        setSelectedProductIndex(index)
    }

    const handleClose = () => {
        setShowDelete(false);
    }
    const handleDelete = () => {
        handleRemoveProductFromList(selectedProductIndex);
        setShowDelete(false);
        setSelectedProductIndex(null);
    }

    const isMobile = useIsMobile();

    return (
		<>
			<div>
				<div className={`${!isMobile ? 'bg-white pt-0' : 'm-0 p-3 p-xl-4 w-100 new-card'}`}>
					<div style={{borderBottom: '1px solid #eee', width: '100%'}}>
						<h5>Inbounded Products</h5>
					</div>

					{inboundList.length > 0 ? (
						<Scroller extraHeight={topSection?.current?.clientHeight || 0}>
							<div>
								{inboundList?.map((item, index) => (
									<div
										key={index}
										className="inbound-mobile-row"
										style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											padding: '12px 0',
											borderBottom: '1px solid #eee',
											background: '#fff'
										}}
									>
										<div style={{ flex: 2, minWidth: 0 }}>
											<div style={{ fontWeight: 500, fontSize: 14 }}>{item.imei ? item?.imei : 'No IMEI'}</div>
											<div style={{ fontSize: 13, color: '#444', marginTop: 2 }}>{item.productName}</div>
											<div style={{ fontSize: 13, color: '#444', marginTop: 2 }}>{item.colorName && item?.colorName}</div>
										</div>

										<div style={{ flexShrink: 0, marginLeft: 10, display: 'flex', flexDirection: 'column', gap: 10 }}>
											<div style={{ flex: 1, minWidth: 0, textAlign: 'center' }}>
												<StatusBadge itemStatus={item?.status} />
											</div>
											<div
												className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
												style={{ minWidth: 'unset' }}
												onClick={() => removeProductFromList(index)}
											>
												<div style={{ margin: 'auto 3px' }}>
													<DeleteIcon height="14px" width="14px" />
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</Scroller>
					) : (
						<div className="not-found-container cstm-not-found" style={{ height: '300px', marginBottom: '20px' }}>
							<div className="not-found-icon">
								<img src={NoItemAvailableIcon} style={{ height: '100px', width: '100px' }} />
							</div>
							<h6 className="not-found-text">No inbounded product </h6>
						</div>
					)}
				</div>
			</div>

			{showDelete && (
				<DeleteConfirmation
					show={showDelete}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete ${operationDetails?.products[selectedProductIndex]?.product_name} ${
						operationDetails?.products[selectedProductIndex]?.color_name
							? `(${operationDetails?.products[selectedProductIndex]?.color_name})`
							: ``
					} from the list?`}
				/>
			)}
		</>
	);
};

export default InboundListMobile;
